import React, { useEffect, useState } from "react";
import API_BASE from "../config.js";
import { authFetch } from "../services/authFetch";

// AUD-A1c-2 -- faixa de primeiro acesso.
//
// Por que estado em modulo e nao Context: a faixa e o "?" ficam em
// pontos diferentes da tela (a faixa abaixo do cabecalho, o "?" ao lado
// do titulo) e precisam concordar entre si. Um Provider resolveria, mas
// obrigaria a mexer no Layout, que e compartilhado por todas as telas --
// exatamente o que nao se quer tocar. Este arquivo e autocontido: as
// telas so importam dois componentes.

const API = "" + API_BASE + "/api/v1/dados";

function tenantDoToken() {
  try {
    const token = (sessionStorage.getItem("access_token") || localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1"; }
}

const estado = { carregado: false, ativo: false, vistas: [], forcadas: [], clicados: [] };

// AUD-A1c-2b -- o pulso da pilha de ajuda.
//
// Tres regras, e as tres existem para que isto nunca vire ruido:
//   1. so no periodo de teste;
//   2. so depois que a pessoa fechou a faixa -- e o momento em que ela
//      precisa saber para onde a explicacao foi;
//   3. tres repeticoes e para sozinho, e para de vez no primeiro clique.
// Animacao continua num elemento que fica o dia inteiro na tela cansa
// justamente quem esta na correria.
const CSS_PULSO = [
  "@keyframes saasglPulsoDica {",
  "  0%   { box-shadow: 0 0 0 0 rgba(99,102,241,0.55); }",
  "  70%  { box-shadow: 0 0 0 9px rgba(99,102,241,0); }",
  "  100% { box-shadow: 0 0 0 0 rgba(99,102,241,0); }",
  "}",
  ".saasgl-pulso-dica { animation: saasglPulsoDica 1.6s ease-out 3; }",
  "@media (prefers-reduced-motion: reduce) {",
  "  .saasgl-pulso-dica { animation: none; }",
  "}",
].join("\n");

let cssPosto = false;
function porCss() {
  if (cssPosto) return;
  cssPosto = true;
  try {
    const el = document.createElement("style");
    el.setAttribute("data-saasgl", "pulso-dica");
    el.appendChild(document.createTextNode(CSS_PULSO));
    document.head.appendChild(el);
  } catch (e) { /* sem DOM: o botao continua funcionando, so nao pulsa */ }
}
const inscritos = new Set();
let promessa = null;

function avisar() {
  inscritos.forEach((f) => { try { f(); } catch (e) { /* um ouvinte quebrado nao derruba os outros */ } });
}

function carregar() {
  // Uma chamada por sessao, mesmo com tres telas montando o componente.
  if (promessa) return promessa;
  promessa = authFetch(API + "/onboarding/" + tenantDoToken(), {})
    .then((r) => (r.ok ? r.json() : { ativo: false, vistas: [] }))
    .catch(() => ({ ativo: false, vistas: [] }))
    .then((d) => {
      // Falha FECHADA: sem resposta clara, nenhuma faixa aparece. Faixa
      // explicativa surgindo para cliente antigo parece regressao.
      estado.ativo = (d && d.ativo) === true;
      estado.vistas = (d && Array.isArray(d.vistas)) ? d.vistas : [];
      estado.carregado = true;
      avisar();
      return d;
    });
  return promessa;
}

function marcarVista(id) {
  if (!estado.vistas.includes(id)) estado.vistas = estado.vistas.concat([id]);
  estado.forcadas = estado.forcadas.filter((x) => x !== id);
  avisar();
  // O estado da tela ja mudou acima: se a gravacao falhar, a faixa some
  // do mesmo jeito nesta sessao e volta na proxima. O contrario -- a
  // faixa insistir na tela apos "Entendi" -- seria pior.
  authFetch(API + "/onboarding/" + tenantDoToken() + "/vista", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ dica: id }),
  }).catch(() => {});
}

function reabrir(id) {
  if (!estado.forcadas.includes(id)) estado.forcadas = estado.forcadas.concat([id]);
  if (!estado.clicados.includes(id)) estado.clicados = estado.clicados.concat([id]);
  avisar();
}

function useOnboarding() {
  const [, setContador] = useState(0);
  useEffect(() => {
    const f = () => setContador((n) => n + 1);
    inscritos.add(f);
    carregar();
    return () => { inscritos.delete(f); };
  }, []);
  return estado;
}

export function Dica({ id, texto, jaUsou }) {
  const e = useOnboarding();
  const forcada = e.forcadas.includes(id);
  if (!forcada) {
    if (!e.carregado) return null;
    if (!e.ativo) return null;
    // A dica que some porque virou pratica vale mais que a dica que some
    // porque foi fechada: quem ja tem registro nesta tela nao precisa da
    // explicacao dela.
    if (jaUsou) return null;
    if (e.vistas.includes(id)) return null;
  }
  return (
    <div style={{
      alignItems: "center",
      background: "#6366f115",
      border: "1px solid #6366f155",
      borderRadius: 10,
      color: "var(--text)",
      display: "flex",
      fontSize: 13,
      gap: 12,
      justifyContent: "space-between",
      lineHeight: 1.5,
      padding: "12px 16px",
    }}>
      <span>{texto}</span>
      <button type="button" onClick={() => marcarVista(id)} style={{
        background: "#6366f1",
        border: "none",
        borderRadius: 8,
        color: "#fff",
        cursor: "pointer",
        flexShrink: 0,
        fontSize: 12,
        fontWeight: 700,
        padding: "7px 16px",
      }}>Entendi</button>
    </div>
  );
}

export function BotaoDica({ id, rotulo }) {
  const e = useOnboarding();
  // Sem porteiro de trial no botao, de proposito: um botao de ajuda nunca
  // e ruido, e o funcionario novo de uma oficina antiga tem a mesma duvida
  // que o cliente de primeira viagem. A faixa automatica e o pulso e que
  // sao so do periodo de teste; a pilha em si e de todos.
  porCss();
  const pulsa = e.ativo && e.vistas.includes(id) && !e.clicados.includes(id);
  return (
    <button type="button" className={pulsa ? "saasgl-pulso-dica" : undefined}
      title="O que faz esta tela" aria-label="O que faz esta tela"
      onClick={() => reabrir(id)} style={{
        alignItems: "center",
        background: "transparent",
        border: "1px solid var(--border)",
        borderRadius: 99,
        color: "var(--text2)",
        cursor: "pointer",
        display: "inline-flex",
        flexShrink: 0,
        fontSize: 12,
        fontWeight: 600,
        gap: 5,
        lineHeight: 1,
        padding: "4px 11px 4px 7px",
      }}>
      <span aria-hidden="true" style={{
        alignItems: "center",
        border: "1px solid currentColor",
        borderRadius: 99,
        display: "inline-flex",
        fontSize: 10,
        fontWeight: 700,
        height: 14,
        justifyContent: "center",
        width: 14,
      }}>?</span>
      {rotulo || "Dúvidas"}
    </button>
  );
}

export default Dica;
